import { effect, inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MultiLanguageService {

  translateService = inject(TranslateService);

  languageSignal = signal<string>(
    window.localStorage.getItem('language') ?? 'en'
  );

  constructor() { 
    effect(() => {
      window.localStorage.setItem('language', this.languageSignal());
      this.translateService.use(this.languageSignal());
    })
  }

  updateLangage(language: string) {
    this.languageSignal.update(() => {
      switch (language) {
        case 'en': return 'en'
        case 'es': return 'es'
        case 'fr': return 'fr'
        default: return 'en';
      }
    })
  }
}
